import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { PageLayoutComponent } from '../../../shared/layouts/page-layout/page-layout.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { AppService } from '../../services/app.service';
import {
    EstablishmentEmptyStateComponent,
} from '../../components/establishment-empty-state/establishment-empty-state.component';
import {
    EstablishmentPickerComponent,
} from '../../components/establishments/establishment-picker/establishment-picker.component';

@Component({
    selector: 'app-home-page',
    imports: [
        PageLayoutComponent,
        EstablishmentEmptyStateComponent,
        EstablishmentPickerComponent,
    ],
    templateUrl: './home-page.component.html',
    styleUrl: './home-page.component.scss',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HomePageComponent {

    organization = toSignal(this.appContextService.organization$);
    establishment = toSignal(this.appContextService.establishment$);

    constructor(
        private readonly appContextService: AppService,
    ) {
    }
}
